import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createEnrichedMeetingType, deleteEnrichedMeetingType, getEnrichedMeetingType, queryEnrichedMeetingTypes, updateEnrichedMeetingType } from '@wix/ambassador-asa-v1-enriched-meeting-type/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { EnrichedMeetingTypeClientBase } from './EnrichedMeetingTypeClientBase';
export class EnrichedMeetingTypeClient extends HttpBaseClient(EnrichedMeetingTypeClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getEnrichedMeetingTypeImpl", getEnrichedMeetingType);
    _defineProperty(this, "updateEnrichedMeetingTypeImpl", updateEnrichedMeetingType);
    _defineProperty(this, "createEnrichedMeetingTypeImpl", createEnrichedMeetingType);
    _defineProperty(this, "deleteEnrichedMeetingTypeImpl", deleteEnrichedMeetingType);
    _defineProperty(this, "queryEnrichedMeetingTypesImpl", queryEnrichedMeetingTypes);
  }
}
//# sourceMappingURL=EnrichedMeetingTypeClientHttp.js.map